import { render, staticRenderFns } from "./BlogsHome.vue?vue&type=template&id=0db6c342&"
import script from "./BlogsHome.vue?vue&type=script&lang=js&"
export * from "./BlogsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports